import { compose, composeU } from '@bem-react/core';
import {
    Textinput as TextInputPresenter,
    withBaseline,
    withHasClear,
    withPinRoundRound,
    withSizeM,
    withSizeS,
    withThemeNormal
} from '@yandex-lego/components/Textinput/desktop';

import 'client/common/components/lego/text-input/index.css';

const Textinput = compose(
    withBaseline,
    withHasClear,
    withThemeNormal,
    withPinRoundRound,
    composeU(withSizeS, withSizeM)
)(TextInputPresenter);

export default Textinput;
